import Nullstack from 'nullstack';
export default function IconArrowRampLeft2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrow-ramp-left-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M18 3v8.707"
  }), "   ", Nullstack.element("path", {
    d: "M8 14l-4 -4l4 -4"
  }), "   ", Nullstack.element("path", {
    d: "M18 21c0 -6.075 -4.925 -11 -11 -11h-3"
  }), " ");
}